/**
 * 拓扑插件-拓扑插件自定义交互事件
 */
// import addEdgeBehavior from './addEdgeBehavior';
import addNodeBehavior from './node_behavior';
import previewBehavior from './preview_behavior';
import attributeBehavior from './attribute_behavior';

const customBehaviors = {
  addNodeBehavior,
  previewBehavior,
  attributeBehavior
};

export default function(G6) {
  Object.values(customBehaviors).forEach(item => {
    if (item && item.name && item.options) {
      G6.registerBehavior(item.name, item.options);
    }
  });
}
